<ion-button
  *ngIf="showTrigger"
  [fill]="fill"
  [color]="color"
  [size]="size"
  class="what-is-kilnlink-trigger"
  [attr.aria-label]="'LANDING.WHAT_IS_KILNLINK' | translate"
  (click)="open($event)">
  <ion-icon slot="icon-only" name="help-circle-outline" aria-hidden="true"></ion-icon>
</ion-button>

<ion-modal
  [isOpen]="isOpen"
  (didDismiss)="isOpen = false"
  class="what-is-kilnlink-modal">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title>{{ 'LANDING.WHAT_IS_KILNLINK' | translate }}</ion-title>
        <ion-buttons slot="end">
          <ion-button fill="clear" (click)="close()">{{ 'LANDING.WHAT_IS_KILNLINK_DONE' | translate }}</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding what-is-kilnlink-content">
      <p class="what-is-kilnlink-intro">{{ 'LANDING.WHAT_IS_KILNLINK_INTRO' | translate }}</p>
      <ul class="what-is-kilnlink-list">
        <li *ngFor="let bullet of bullets">{{ bullet }}</li>
      </ul>
      <ion-button expand="block" class="what-is-kilnlink-dismiss" (click)="close()">
        {{ 'LANDING.WHAT_IS_KILNLINK_DONE' | translate }}
      </ion-button>
    </ion-content>
  </ng-template>
</ion-modal>
